import { render, staticRenderFns } from "./sjyyCwhd.vue?vue&type=template&id=68704f72&scoped=true"
import script from "./sjyyCwhd.vue?vue&type=script&lang=js"
export * from "./sjyyCwhd.vue?vue&type=script&lang=js"
import style0 from "./sjyyCwhd.vue?vue&type=style&index=0&id=68704f72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68704f72",
  null
  
)

export default component.exports